module.exports = __webpack_public_path__ + "img/fukuokaseikei.fb912dbf.jpg";